import type { useTranslations } from 'next-intl';

type Translate = ReturnType<typeof useTranslations<'auth.login'>>;

export function getEmailErrorMessage(t: Translate, code: string | undefined) {
  if (!code) return undefined;
  const map: Record<string, string> = {
    required: t('errors.email.required'),
    invalid: t('errors.email.invalid'),
  };
  return map[code] ?? code;
}

export function getPasswordErrorMessage(t: Translate, code: string | undefined) {
  if (!code) return undefined;
  const map: Record<string, string> = {
    required: t('errors.password.required'),
    too_short: t('errors.password.too_short'),
  };
  return map[code] ?? code;
}

export function getLoginApiErrorMessage(t: Translate, code: string): string {
  switch (code) {
    case 'invalid_credentials':
      return t('errors.api.invalid_credentials');
    case 'account_disabled':
      return t('errors.api.account_disabled');
    case 'rate_limited':
      return t('errors.api.rate_limited');
    default:
      return t('errors.api.server_error');
  }
}
